import {appUrls} from "constants/urls";
import axiosInstance from "utils/axiosInstance";

export const getTime = async () => {
    const response = await axiosInstance.get(appUrls.getCurrentTime);
    return response?.data;
};